import { useEffect, useState } from 'react'
import { Autocomplete, Box, Checkbox, TextField } from '@mui/material'
import { connect } from 'react-redux'
import _ from 'lodash'
import DashboardCard from '../../components/DashboardCard'
import { useStyles } from './style'
import { dashboardService } from '../../services/DashboardService'
import { DisplayMessage, Loader } from '../../components'
import * as messageTypes from '../../utils/messageTypes'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { KeyboardArrowDown } from '@mui/icons-material'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />
const ALL = 'ALL'
const Dashboard = (props) => {
  const classes = useStyles()
  const [allPrograms, setAllPrograms] = useState([])
  const [selectedPrograms, setSelectedPrograms] = useState([{ id: ALL, name: ALL }])
  const [programs, setPrograms] = useState([])
  const [dropdownPrograms, setDropdownPrograms] = useState([])
  const [allAccounts, setAllAccounts] = useState([])
  const [selectedAccounts, setSelectedAccounts] = useState([{ id: ALL, name: ALL }])
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [loading, setLoading] = useState(false)

  const getAllPrograms = () => {
    setLoading(true)
    dashboardService.getAllPrograms()
      .then(programsData => {
        setLoading(false)
        let filteredPrograms = []
        if (props.currentUser && props.currentUser.is_installer) {
          filteredPrograms = programsData.filter(program => program.feature_flags && program.feature_flags.installer_intake)
        }
        else {
          filteredPrograms = programsData.filter(program => program.feature_flags && program.feature_flags.customer_support_verification)
        }
        let modifiedList = [], accounts = [{ id: ALL, name: ALL }], uniqueAccountIds = []
        filteredPrograms.forEach(obj => {
          const familyKey = obj.family_key
          const index = familyKey ? modifiedList.findIndex(e => e.familyKey === familyKey) : -1
          if (index === -1) {
            modifiedList.push({ familyKey, program: [obj] })
          } else {
            modifiedList[index].program.push(obj)
          }
          if (!uniqueAccountIds.includes(obj.account_id)) {
            uniqueAccountIds.push(obj.account_id)
            let account = { id: obj.account_id, name: obj.account_name }
            accounts.push(account)
          }
        })
        setAllAccounts(accounts)
        setPrograms(modifiedList)
        setAllPrograms(programsData)
        setDropdownPrograms(programsData)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  useEffect(() => {
    getAllPrograms()
  }, [])

  useEffect(() => {
    let filteredPrograms = []
    if (props.currentUser && props.currentUser.is_installer) {
      filteredPrograms = allPrograms.filter(program => program.feature_flags && program.feature_flags.installer_intake)
    }
    else {
      filteredPrograms = allPrograms.filter(program => {
        return program.feature_flags && program.feature_flags.customer_support_verification && selectedAccounts.find(account => account.id === ALL ? true : program.account_id === account.id)
      })
    }
    let modifiedList = []
    filteredPrograms.forEach(obj => {
      const familyKey = obj.family_key
      const index = familyKey ? modifiedList.findIndex(e => e.familyKey === familyKey) : -1
      if (index === -1) {
        modifiedList.push({ familyKey, program: [obj] })
      } else {
        modifiedList[index].program.push(obj)
      }
    })
    setPrograms(modifiedList)
    setDropdownPrograms(filteredPrograms)
  }, [selectedAccounts])

  return (
    <>
      <Loader loading={loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <Box className={classes.headerContainer}>
        <Box className={classes.headingText} mb={3}>{`Welcome ${_.get(props, 'currentUser.first_name', '')}!`}</Box>
        <Box className={classes.subHeading} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
          <Box my={1}>
            {`Choose a program ${props.currentUser && props.currentUser.is_installer ? 'to track or submit' : 'from below to verify'} homeowner applications.`}
          </Box>
          {!props?.currentUser?.is_installer &&
            <>
              <Box className={classes.filter}>
                <Box my={1} mr={1}>
                  <Autocomplete
                    id="accounts"
                    multiple
                    size="small"
                    popupIcon={<KeyboardArrowDown />}
                    disableCloseOnSelect
                    options={allAccounts}
                    value={selectedAccounts}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    onChange={(event, value) => { setSelectedAccounts(value); setSelectedPrograms([{ id: ALL, name: ALL }]) }}
                    getOptionLabel={(option) => option.name}
                    getOptionDisabled={(option) => {
                      if (selectedAccounts.find(account => account.id === ALL)) {
                        return option.id !== ALL
                      } else if (selectedAccounts.length !== 0) {
                        return option.id === ALL
                      }
                    }}
                    renderOption={(props, option, { selected }) => {
                      return (
                        <li {...props}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.name}
                        </li>
                      )
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputProps={{ ...params.InputProps, startAdornment: `${selectedAccounts.find(account => account.id === ALL) ? 'ALL' : selectedAccounts.length + ' Selected'}` }}
                        label="Accounts"
                        variant='standard'
                        error={selectedAccounts.length === 0}
                        helperText={selectedAccounts.length === 0 && 'Please select an account'}
                      />
                    )}
                    sx={{ width: '300px' }}
                  />
                </Box>
                <Box my={1}>
                  <Autocomplete
                    id="programs"
                    multiple
                    size="small"
                    popupIcon={<KeyboardArrowDown />}
                    disableCloseOnSelect
                    options={[{ id: ALL, name: ALL }, ...dropdownPrograms]}
                    value={selectedPrograms}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    onChange={(event, value) => {
                      setSelectedPrograms(value)
                      let filteredPrograms = []
                      if (props.currentUser && props.currentUser.is_installer) {
                        filteredPrograms = dropdownPrograms.filter(program => program.feature_flags && program.feature_flags.installer_intake)
                      }
                      else {
                        filteredPrograms = dropdownPrograms.filter(program => {
                          return program.feature_flags && program.feature_flags.customer_support_verification && value.find(val => val.id === ALL ? true : program.id === val.id)
                        })
                      }
                      let modifiedList = []
                      filteredPrograms.forEach(obj => {
                        const familyKey = obj.family_key
                        const index = familyKey ? modifiedList.findIndex(e => e.familyKey === familyKey) : -1
                        if (index === -1) {
                          modifiedList.push({ familyKey, program: [obj] })
                        } else {
                          modifiedList[index].program.push(obj)
                        }
                      })
                      setPrograms(modifiedList)
                    }}
                    getOptionLabel={(option) => option.name}
                    getOptionDisabled={(option) => {
                      if (selectedPrograms.find(program => program.id === ALL)) {
                        return option.id !== ALL
                      } else if (selectedPrograms.length !== 0) {
                        return option.id === ALL
                      }
                    }}
                    renderOption={(props, option, { selected }) => {
                      return (
                        <li {...props}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.name}
                        </li>
                      )
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputProps={{ ...params.InputProps, startAdornment: `${selectedPrograms.find(program => program.id === ALL) ? 'ALL' : selectedPrograms.length + ' Selected'}` }}
                        label="Programs"
                        variant='standard'
                        error={selectedPrograms.length === 0}
                        helperText={selectedPrograms.length === 0 && 'Please select a program'}
                      />
                    )}
                    sx={{ width: '300px' }}
                  />
                </Box>
              </Box>
            </>
          }
        </Box>
      </Box>
      <Box className={classes.contentContainer}>
        {programs.map(obj => {
          const { program } = obj
          const utilities = program.map(list => ({
            name: list.utility_name,
            logo: list.utility_logo,
            state: list.state_name,
            account: list.account_name
          }))
          return <DashboardCard key={program[0].id} program={program} utility={utilities} state={_.get(program[0], 'state_name', '')} account={_.get(program[0], 'account_name', '')} />
        })}
        {[0, 1, 2].map(() => <Box className={classes.fillerCards} />)}
      </Box>
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser } = auth
  return { currentUser }
}
export default connect(mapStateToProps, {})(Dashboard)